import { createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { RemoteIOModels } from '@models/remote-io.models';
import { RemoteIOActions } from '@states/remote-io/remote-io.action-types';

export interface RemoteIOState extends EntityState<RemoteIOModels.RemoteIODocument> {
  isInitialLoaded: boolean;
  filters: {
    query: string
  };
  isSaving: boolean;
  selectedRemoteIODocument: RemoteIOModels.RemoteIODocument;
  isFormValid: boolean;
  remoteIOConnected: boolean;
}

export const adapter: EntityAdapter<RemoteIOModels.RemoteIODocument> = createEntityAdapter<RemoteIOModels.RemoteIODocument>({
  selectId: (document: RemoteIOModels.RemoteIODocument) => document._id,
});

export const initialState: RemoteIOState = adapter.getInitialState({
  isInitialLoaded: false,
  filters: {
    query: null,
  },
  isSaving: false,
  selectedRemoteIODocument: null,
  isFormValid: false,
  remoteIOConnected: false,
});

export const remoteIOStateReducer = createReducer(
  initialState,
  on(RemoteIOActions.resetToInitialState, state => {
    return {
      ...initialState,
    };
  }),
  on(RemoteIOActions.getRemoteIOsSuccess, (state, { documents }) => {
    return adapter.setMany(documents, {
      ...state,
      isInitialLoaded: true,
    });
  }),
  on(RemoteIOActions.setSelectedRemoteIO, (state, { document }) => {
    return {
      ...state,
      selectedRemoteIODocument: document,
    };
  }),
  on(RemoteIOActions.setQueryStringFilter, (state, { prop, value }) => {
    return {
      ...state,
      filters: {
        ...state.filters,
        [prop]: value,
      },
    };
  }),
  on(RemoteIOActions.resetEntities, (state) => {
    return {
      ...state,
      entities: initialState.entities,
    };
  }),
  on(RemoteIOActions.testRemoteIOSuccess, (state) => {
    return {
      ...state,
      remoteIOConnected: true,
    };
  }),
  on(RemoteIOActions.setIsSaving, (state, { isSaving }) => {
    return {
      ...state,
      isSaving: isSaving,
    };
  }),
  on(RemoteIOActions.deleteRemoteIOSuccess, (state, { remoteIOId }) => {
    return adapter.removeOne(remoteIOId, {
      ...state,
    });
  }),
  on(RemoteIOActions.getOneRemoteIOSuccess, (state, { document }) => {
    return {
      ...state,
      selectedRemoteIODocument: document,
    };
  }),
  on(RemoteIOActions.changeFormValidation, (state, { isFormValid }) => {
    return {
      ...state,
      isFormValid,
    };
  }),
); 